/* eslint-disable */
import React, { useState, useContext, createContext, useCallback } from "react"
import { getAudioSamples } from "./audioSamples"

import { Buffer } from "buffer"

const AudioContext = createContext()

export const AudioProvider = ({ children }) => {
	const [audio, setAudio] = useState(null)
	const [samples, setSamples] = useState(null)
	const [device, setDevice] = useState(null)

	const [page, setPage] = useState(1)
	const [loading, setLoading] = useState({
		device: false,
		waveform: false,
		convert: false,
	})

	const initialError = {
		device: "",
		convert: "",
		audio: "",
	}

	const [error, setError] = useState(initialError)

	const getDevice = useCallback(async (device) => {
		try {
			const getDeviceHandler = async () => {
				setTimeout(() => {
					setLoading((loading) => ({ ...loading, device: false }))
				}, 100)
			}
			closeDevice()
			setLoading((loading) => ({ ...loading, device: true }))
			const result = await fetch(`http://localhost:5003/check_device/${device}`, { method: "POST" })
			if (result.status === 200) {
				const { raw, wav } = await result.json()
				setDevice({ device, raw, wav })
			} else {
				const { message } = await result.json()
				setError((error) => ({ ...error, device: message }))
			}
			await getDeviceHandler()
		} catch (error) {
			console.log(error.message)
		}
	}, [])

	const closeDevice = () => {
		setDevice(null)
		setError({
			device: "",
			convert: "",
			audio: "",
		})
		setAudio(null)
		setSamples(null)
	}

	const getAudio = useCallback(async (device) => {
		try {
			const getAudioHandler = async () => {
				setTimeout(() => {
					setLoading((loading) => ({ ...loading, waveform: false }))
				}, 500)
			}
			const resetAudio = async () => {
				setAudio(null)
				setSamples(null)
			}
			await resetAudio()
			setLoading((loading) => ({ ...loading, waveform: true }))
			const audioData = await (await fetch(`http://localhost:5003/get_data/${device}`)).json()
			const { sampling_rate } = audioData
			const audioBuffer = await (await fetch(`http://localhost:5003/get_buffer/${device}`)).arrayBuffer()

			const { t, v } = await getAudioSamples(Buffer.from(audioBuffer), sampling_rate)
			if (t.length) {
				setAudio(audioData)
				setSamples({ t, v })
			} else {
				await resetAudio()
			}
			await getAudioHandler()
		} catch (error) {
			setError((error) => ({ ...error, audio: "Cannot read audio." }))
		}
	}, [])

	const createAudio = async () => {
		const createAudioHandler = async () => {
			setTimeout(() => {
				setLoading((loading) => ({ ...loading, convert: false }))
			}, 500)
		}
		setLoading((loading) => ({ ...loading, convert: true }))
		const result = await fetch(`http://localhost:5003/get_wav/${device.device}`, {
			method: "POST",
			body: JSON.stringify({
				file_name: `${device.device}.wav`,
				sampling_rate: 16000,
			}),
		})
		if (result.status === 200) {
			setDevice((device) => ({ ...device, wav: true }))
			await getAudio(device.device)
		} else {
			const { message } = await result.json()
			setError((error) => ({ ...error, convert: message }))
		}
		await createAudioHandler()
	}

	const closeAudioPlot = () => {
		setAudio(null)
		setSamples(null)
	}

	const value = {
		audio,
		setAudio,
		samples,
		setSamples,
		getAudio,
		loading,
		closeAudioPlot,
		error,
		setError,
		page,
		setPage,
		device,
		getDevice,
		closeDevice,
		createAudio,
	}

	return <AudioContext.Provider value={value}>{children}</AudioContext.Provider>
}

const useAudioContext = () => useContext(AudioContext)

export default useAudioContext

